import React from 'react';
import ExerciseResults from '../shared/ExerciseResults';

const VocabularyFillInResults = ({ exercises, userResponses, restart, onBack, engagementData, engagementLoading }) => {
  // Calculate statistics
  const correctCount = Object.values(userResponses).filter(response => response.correct).length;
  const totalExercises = exercises.length;

  return (
    <ExerciseResults
      title="Výsledky - Slovíčka"
      score={correctCount}
      total={totalExercises}
      color="amber"
      onRestart={restart}
      onBack={onBack}
      engagementData={engagementData}
      engagementLoading={engagementLoading}
    >
      {/* Detailed Results */}
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Detailní výsledky
      </h3>

      <div className="flex flex-col gap-3">
        {exercises.map((exercise, index) => {
          const response = userResponses[index];
          const isCorrect = response?.correct === true;
          // Revealed ("Nevím") answers are stored as seen — treat as unanswered.
          const userAnswer = response && !response.seen ? response.answer : '';

          return (
            <div
              key={exercise.id ?? index}
              className={`p-4 rounded-lg ${isCorrect ? 'bg-green-50' : 'bg-red-50'}`}
            >
              <div className="flex items-start gap-3">
                <span className="text-amber-600 font-semibold min-w-[30px]">
                  #{index + 1}
                </span>
                <div className="flex-1">
                  <div className="text-gray-800 mb-2">
                    {exercise.sentence_before}{' '}
                    <strong className={isCorrect ? 'text-green-600' : 'text-red-500 line-through'}>
                      {userAnswer || '(nevyplneno)'}
                    </strong>
                    {' '}{exercise.sentence_after}
                  </div>
                  {!isCorrect && (
                    <div className="text-sm text-gray-600">
                      <strong>Správná odpověd:</strong> {exercise.sentence_before}{' '}
                      <strong className="text-green-600">{exercise.correct_answer}</strong>
                      {' '}{exercise.sentence_after}
                    </div>
                  )}
                  <div className={`text-sm font-medium mt-2 ${isCorrect ? 'text-green-600' : 'text-red-500'}`}>
                    {isCorrect ? '✓ Správně' : '✗ Špatně'}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </ExerciseResults>
  );
};

export default VocabularyFillInResults;
